import { unit } from 'mathjs';

export const formatNumberWithCommas = (n: number | string): string => {
  const num = typeof n === 'string' ? parseFloat(n) : n;
  
  // If it's a whole number (including 3.0, 969.0, etc.), don't add .00
  if (Number.isInteger(num)) {
    return num.toLocaleString(undefined, { maximumFractionDigits: 0 });
  }
  
  // For decimals, show up to 2 decimal places but remove trailing zeros
  // Use toFixed to control precision, then remove trailing zeros
  const formatted = num.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  // Remove trailing zeros and decimal point if not needed (e.g., "3.00" -> "3", "3.50" -> "3.5")
  return formatted.replace(/\.?0+$/, '');
};

export const formatNumber = (n: number): string => {
  if (n >= 1_000_000 || (n > 0 && n < 0.01)) {
    return n.toExponential(2);
  }
  return n.toFixed(2).replace(/\.?0+$/, '');
};

export const convertWithMathjs = (numValue: number, fromName: string, toName: string): string => {
  try {
    const result = unit(numValue, fromName);
    const numeric = result.toNumber(toName);

    if (Number.isNaN(numeric)) return '0';

    return formatNumber(numeric);
  } catch {
    return '0';
  }
};
